import styled from 'styled-components';

export const BackgroundWrapper = styled.div`
  background: white;
  border-radius: 8px;
  height: 100%;
  // overflow: hidden;
  display: flex;
  flex-direction: column;
`;
